import Money from '../../Parts/Money';
import { useQuoteAccessories } from '../../Store/entities/accessories/hooks';
import { useUserMultiplier } from '../../hooks';

const AccessoryRow = ({ quote, accessory }) => {
	const acc = accessory;

	const pricing_data = acc;

	if (!pricing_data) {
		return (
			<tr />
		);
	}

	return (
		<tr>
			<td>{ acc.name }</td>
			<td>{ pricing_data ? pricing_data.quantity : null }</td>
			<td>
				<Money>
					{ pricing_data ? pricing_data.price : null }
				</Money>
			</td>
			<td>
				<Money>
					{ pricing_data ? pricing_data.total : null }
				</Money>
			</td>
		</tr>
	);
};

export default function AccessoriesTable({ quote, displayData }) {
	const userMultiplier = useUserMultiplier();

	const qas = useQuoteAccessories(quote.ID);

	const rows = qas
		.filter((acc) => parseInt(acc.quantity) > 0)
		.map((acc) => <AccessoryRow key={`${acc.name}-${acc.line_number}`} quote={quote} accessory={acc} />);

	return (

		<table className="invoice-table" border="0" cellSpacing="0" cellPadding="0">
			<tbody>
				<tr className="bold-row">
					<th colSpan="42">Accessories</th>
				</tr>
				<tr>
					<th>Name</th>
					<th>Quantity</th>
					<th>Price</th>
					<th>Total</th>
				</tr>
				{ rows }
			</tbody>
		</table>
	);
}
